import React, { useState } from "react";
import styles from "./sidebar.module.css";


const Sidebar = ({ chats, activeChatId, onActiveChatIdChange, onNewChatCreate, activeChatMessages}) => {
    const [isOpen, setIsOpen] = useState(false);
    function handlesideartoggle(){
        setIsOpen(!isOpen)
    }
    const handleEscapePress =(event)=>{
      if(isOpen && event.key === "Escape"){
        setIsOpen(false);
      }
    }

    const handleChatClick = (chatId) =>{
      onActiveChatIdChange(chatId);
      if(isOpen){
        setIsOpen(!isOpen)
      }
    }


  return (
    <>
     <button className={styles.menuButton} onClick={handlesideartoggle} onKeyDown={handleEscapePress}>
        <MenuIcon/>
     </button>
      <div className={styles.sidebar} data-open={isOpen}>
        <button className={styles.newChatButton} disabled={activeChatMessages.length === 0} onClick={onNewChatCreate}> New Chat</button>
        <ul className={styles.chats}>
          {chats
          .filter(({ messages }) => messages.length > 0)
          .map((chat) => {
            return (
              <li
                key={chat.id}
                className={styles.chat}
                data-active={chat.id === activeChatId}
                onClick={()=>handleChatClick(chat.id)}
              >
                <button className={styles.chatbutton}>
                  <div className={styles.ChatTitle}>{chat.title}</div>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      {isOpen && <div className={styles.overlay} onClick={handlesideartoggle}/>}
    </>
  );
};

const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1f1f1f"
    >
      <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
    </svg>
  );
};

export default Sidebar;
